/**
 * Semver comparison, shared by the app and the service so a floor is never interpreted two
 * different ways. Numeric part by part: `1.10.0` is newer than `1.9.0`, which a plain
 * string compare denies — and that is a real release the day a project passes version 9.
 */
export function compareVersions(a: string, b: string): number {
  const pa = a.split(".").map((n) => Number.parseInt(n, 10) || 0);
  const pb = b.split(".").map((n) => Number.parseInt(n, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i += 1) {
    const diff = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (diff !== 0) return diff < 0 ? -1 : 1;
  }
  return 0;
}
